module.exports = __webpack_public_path__ + "img/张红楼.21edf0d7.jpg";